type ToastType = 'success' | 'error' | 'warning' | 'info'

interface Toast {
  id: number
  type: ToastType
  message: string
}

export const useToastState = () => useState<Toast[]>('toasts', () => [])

export function useToast() {
  const toasts = useToastState()
  let counter = 0

  function show(type: ToastType, message: string, duration = 4000) {
    const id = ++counter
    toasts.value.push({ id, type, message })
    setTimeout(() => remove(id), duration)
  }

  function remove(id: number) {
    toasts.value = toasts.value.filter((t) => t.id !== id)
  }

  return {
    success: (msg: string) => show('success', msg),
    error: (msg: string) => show('error', msg),
    warning: (msg: string) => show('warning', msg),
    info: (msg: string) => show('info', msg),
    remove,
  }
}
